import React from 'react';
import './RateList.css';
import RateListTable from './RateListTable';
import Note from './Note';
import Amenities from './Amenities';
import InteriorDetail from './InteriorDetail';

const RateListPlots = ({...props}) => {
    const tableData = props.rowDataRate;
    const tableHead = props.columnDataRate;
    const noteData = props.noteData;
    const amenitiesData = props.amenitiesData;
    const interiorDt = props.interiorData;

    return (
        <div className='flex flex-col py-4 px-4 md:px-7 bg-white box-shadow rounded-xl'>
            <h2 className='text-xl leading-8 font-bold uppercase font-montserrat pb-2 mb-4 text-gray-900 text-center border-b border-gray-200 border-solid'>{props.title}</h2>
            <RateListTable tableHead={tableHead} tableData={tableData} title={props.title} />
            <Note noteData={noteData} />
            {amenitiesData.map((amenitiesText)=>{
                return (
                    <Amenities key={amenitiesText.id} title={amenitiesText.title} amenitiesData={amenitiesText.amenitiesData} />
                );
            })}            
            <InteriorDetail interiorContent={interiorDt}  />
        </div>
    );
}

export default RateListPlots;